import React from 'react'
import BaseChart from 'src/Components/shared/Chart'

import styles from './Chart.module.scss'

const Chart = props => (
  <div className={styles.container}>
    <BaseChart {...props} className={styles.chart} />
  </div>
)

export default Chart
